import _ from "lodash";

const assets = {
  background_1920: require("../../../assets/wc/videos/background_1920x1080_v2.webm"),
  qatar_logo: require("../../../assets/wc/images/insight_zone_white.png"),
};

export default assets;
